/**
 * Job sidebar order fetched successful action.
 */
export const JOB_SIDEBAR_ORDER_FETCHED = "JOB_SIDEBAR_ORDER_FETCHED";
export type JOB_SIDEBAR_ORDER_FETCHED = { order: Array<string> }

/**
 * Job sidebar order updated successful action.
 */
export const JOB_SIDEBAR_ORDER_UPDATED = "JOB_SIDEBAR_ORDER_UPDATED";
export type JOB_SIDEBAR_ORDER_UPDATED = { order: Array<string> }

/**
 * Lead sidebar order fetched successful action.
 */
export const LEAD_SIDEBAR_ORDER_FETCHED = "LEAD_SIDEBAR_ORDER_FETCHED";
export type LEAD_SIDEBAR_ORDER_FETCHED = { order: Array<string> }

/**
 * Lead sidebar order updated successful action.
 */
export const LEAD_SIDEBAR_ORDER_UPDATED = "LEAD_SIDEBAR_ORDER_UPDATED";
export type LEAD_SIDEBAR_ORDER_UPDATED = { order: Array<string> }
